import { HttpRequest } from '@lib/http/HttpRequest';

import type { TPayloadValue } from '@lib/types/THttpRequest';
import type { THttpResponse, TReturnable } from '@lib/types/THttpResponse';

/**
 * @private Do not use this class directly
 */
export class DeleteRequest extends HttpRequest {
  constructor(
    endpoint: string,
    tokenTask: () => Promise<Maybe<string>>,
    query?: Maybe<Record<string, TPayloadValue>>,
    body?: Maybe<Record<string, TPayloadValue>>,
    headers?: Maybe<Record<string, string>>,
    tokenRefresher?: Maybe<() => Promise<Maybe<string>>>,
  ) {
    super(endpoint);

    this.setMethod('DELETE');
    this.setTokenFetcher(tokenTask);

    if (tokenRefresher != null) {
      this.setTokenRefresher(tokenRefresher);
    }

    if (body != null) {
      this.setBody(body);
    }

    if (query != null) {
      this.setQuery(query);
    }

    if (headers != null) {
      this.setHeaders(headers);
    }
  }

  public override async send<T extends TReturnable>(): Promise<THttpResponse<T>> {
    return await super.send();
  }
}
